import {XCircleIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useFailedChecksData} from './use-failed-checks-data'

// Surfaces a single summary item when the pull request has failing required checks.
// The parent ForYouItemBoundary decides which subsection (and thus which viewer) sees
// it via its `audience` prop, so this component stays audience-agnostic.
export function FailingChecks({variant}: {variant?: 'default' | 'embedded'}) {
  const failedChecks = useFailedChecksData()

  if (!failedChecks || failedChecks.length === 0) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={XCircleIcon} variant="danger" emphasized />}
      emphasizedLeadingVisual
      title="Required checks failing"
      itemName="failing-checks"
      description="Fix the failing required checks."
      variant={variant}
      actionSlot={
        <Button size="small" variant="default" inactive>
          Merge when ready
        </Button>
      }
    />
  )
}
